import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'chargers',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./features/login/login.routes').then(m => m.routes),
  },
  {
    path: 'password-set',
    loadChildren: () => import('./features/login/login.routes').then(m => m.routes),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./features/login/login.routes').then(m => m.routes),
  },
  {
    path: 'chargers',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/chargers/chargers.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.chargers' }
  },
  {
    path: 'connectors',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/connectors/connectors.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.connectors' }
  },
  {
    path: 'charger-groups',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/charger-groups/charger.group.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.charger-groups' }
  },
  {
    path: 'rfid-groups',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/rfids/rfids.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.rfid-groups' }
  },
  {
    path: 'cdrs',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/cdrs/cdrs.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.cdrs' }
  },
  {
    path: 'locations',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/locations/locations.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.locations' }
  },
  { 
    path: 'companies',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/settings/settings.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.companies' }
  },
  { 
    path: 'grid-operators',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/grid-operators/grid-operators.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.grid-operators' }
  },
  {
    path: 'tariffs',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/tariffs/tariffs.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.tariffs' }
  },
  {
    path: 'configuration-profiles',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/configuration-profiles/configuration-profiles.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.configuration-profiles' }
  },
  {
    path: 'incidents',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/alerts/alerts.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.incidents' }
  },
  {
    path: 'smart-cars',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/smart-cars/smart-cars.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.smart-cars' }
  },
  {
    path: 'onboarding',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/stripe/stripe.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.onboarding' }
  },
  {
    path: 'billing',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/billing/billing.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.billing' }
  },
  {
    path: 'demo',
    loadChildren: () => import('./features/ui-legend/ui-legend.routes').then(m => m.routes),
    data: { breadcrumb: 'breadcrumbs.billing' }
  }
  // other routes like 'rfid', 'projects', 'billing', etc.
];
